exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-ba7d466c]{cursor:pointer}.advice[data-v-ba7d466c]{background-color:#f7f7f7!important}.advice .v-card__title[data-v-ba7d466c]{padding-bottom:8px}.tipsIntro[data-v-ba7d466c]{font-weight:700}.slide-fade-enter-active[data-v-ba7d466c]{transition:all .3s ease}.slide-fade-leave-active[data-v-ba7d466c]{transition:all .8s cubic-bezier(1,.5,.8,1)}.slide-fade-enter[data-v-ba7d466c],.slide-fade-leave-to[data-v-ba7d466c]{transform:translateX(10px);opacity:0}.right-icon[data-v-ba7d466c]{float:right;margin-top:16px;margin-right:16px}", ""]);

// exports
